<template>
  <div class="AddGroupChat">
    <van-nav-bar
      title="发起群聊"
      right-text="创建"
      fixed
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
      <van-button>创建</van-button>
    </van-nav-bar>
    <!-- <van-search
    placeholder="请输入搜索关键词"
    />-->
    <div class="group-content">
      <!-- sticky-offset-top="50"  -->
      <van-index-bar :index-list="FirstPin">
        <van-index-anchor v-for="(item, index) in friends" :key="index" :index="index">
          <van-cell-group class="indexc">
            <div class="indexWord" v-if="item.length > 0">
              <span>{{index}}</span>
            </div>
            <div class="addf" v-for="(it, index) in item" :key="index">
              <van-checkbox-group v-model="result">
                <van-checkbox :name="it.u_id">
                  <div class="iat">
                    <van-image
                      :src="attach_url+it.u_headportrait"
                      width="40px"
                      height="40px"
                      style="margin-top:5px"
                      class="err-image-header"
                    />
                    <van-cell
                      :title="it.f_name.f_name?it.f_name.f_name:it.u_nickname?it.u_nickname:it.u_login_id"
                      :id="it.u_id"
                      @click="onFriendInfo(it.u_id)"
                    />
                  </div>
                </van-checkbox>
              </van-checkbox-group>
            </div>
          </van-cell-group>
        </van-index-anchor>
      </van-index-bar>
    </div>
  </div>
</template>
<script>
var pinyin = require("js-pinyin");
pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
import { FirstPin } from "@/utils/common.js";
export default {
  name: "AddGroupChat",
  data() {
    return {
      FirstPin:FirstPin,
      attach_url: this.Conf.serverPre,
      actionName: "",
      active: "",
      result: [],
      friends: [],
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token")
    };
  },
  methods: {
    loadDate() {
      var params = {
        u_id: this.u_id,
        token: this.token,
        num: Math.random()
      };
      var url = this.Conf.serverUrl + "Friends/index" + "?num="+Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          // console.log("hhhh",response)
          var friend = response.data.friends;
          var firstName = {};
          this.FirstPin.forEach(item => {
            firstName[item] = [];
            friend.forEach(el => {
           let first = ( el.f_name.f_name?el.f_name.f_name:el.u_nickname?el.u_nickname:el.u_login_id).substring(0,1); 
              //  console.log("hhhh",first)
              if (/[a-z]/.test(first)||/^[\u4e00-\u9fa5]*$/.test(first)) {
                first = pinyin.getCamelChars(el.f_name.f_name?el.f_name.f_name:el.u_nickname?el.u_nickname:el.u_login_id).substring(0, 1).toUpperCase() ; // 英文
              } else {
                first = "#";
              }
              if (first == item) {
                firstName[item].push(el);
              }
            });
          });
       
          this.friends = firstName;
          this.newFriends = response.data.newFriendCount;
          this.groupCount = response.data.groupCount;
        })
        .catch(error => {});
    },
    // 返回跳转
    onClickLeft() {
      this.$router.go(-1);
    },
    // 创建群
    onClickRight() {
      // console.log(this.result);
      var params = {
        u_id: this.u_id,
        token: this.token,
        member_ids: this.result
      };
      var url = this.Conf.serverUrl + "Groups/createGroup";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          switch (response.data.code) {
            case 200:
              var data = {
                u_id: this.u_id,
                member_ids: this.result, // 群成员id
                ug_id: response.data.ug_id, // 群id
                mk: 7,
                ug_type: "notice"
              };
              this.websocket.ws.send(JSON.stringify(data));
              this.$router.push({
                name: "GroupChatroom",
                query: {
                  ug_id: response.data.ug_id,
                  ug_name: "新建群聊",
                  // url: "AddGroupChat"
                  // url: "AddGroupChat"
                }
              });
              // console.log(response.data);
              break;
            case 40001:
              this.$toast.fail(response.data.msg);
              break;
          }
        })
        .catch(error => {});
    },
    // 获取跳转前页面路径
    getAction() {
      var params = this.$route.query;
      this.actionName = params.actionName;
      this.active = params.active;
    },
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		}
  },
  created() {
  	this.getStateConfigs();
    this.loadDate();
    this.getAction();
  }
};
</script>

<style  lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Group/AddGroupChat.vue